import { HomeComponent } from './home/home/home.component';
// import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadSelectedModulesList } from './app-preloading';

const routes: Routes = [
  {
    path: 'ride',
    loadChildren: './ride/ride.module#RideModule',
    data: { preload: true },
  },
  {
    path: 'lift',
    loadChildren: './lift/lift.module#LiftModule',
    data: { preload: true },
  },
  {
    path: 'dashboard',
    loadChildren: './dashboard/dashboard.module#DashboardModule',
    data: { preload: true },
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
  },
  { path: '**', redirectTo: '' },
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
// export class AppRoutingModule {}

export const AppRouting = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadSelectedModulesList,
});
